import React, { FC, memo } from 'react';
import styled from 'styled-components';

import Landing from './landing';
import QuotationForm from './quotation-form';
import QuotationFiles from './files';
export const Container = styled.div`
  @media (max-width: 576px) {
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 15px;
    margin-left: -15px;
    margin-right: -15px;
  }
  background-color: #fff;
`;

const Quotation: FC = () => {
  return (
    <Container>
      <QuotationForm />
      <Landing />
      <div className="p-3">
        <p>
          Báo giá văn phòng phẩm luôn là mối quan tâm hàng đầu của các khách
          hàng. Hiện nay các nhà cung cấp văn phòng phẩm trên thị trường vô cùng
          đa dạng, từ các cửa hàng nhỏ lẻ cho đến những hiệu sách, đại lý lớn…
          Chính vì vậy mà mức giá sản phẩm cũng khác nhau tùy theo từng đơn vị.
          Trong bài viết này, FAST sẽ gửi đến bạn bảng giá văn phòng phẩm cập
          nhật mới nhất.
        </p>
        <h2>Một số yếu tố tác động đến báo giá văn phòng phẩm</h2>
        <h3>Tình hình sản xuất kinh doanh tại Trung Quốc</h3>
        <p>
          Hiện nay hầu hết các mặt hàng văn phòng phẩm tại Việt Nam đều được
          nhập khẩu từ Trung Quốc. Vì vậy mức giá văn phòng phẩm sẽ phụ thuộc
          vào tình hình sản xuất kinh doanh tại Trung Quốc, giá nguyên vật liệu
          và chi phí qua cửa khẩu.
        </p>
        <h3>Tùy theo từng khu vực</h3>
        <p>
          Biến động giá của các mặt hàng văn phòng phẩm cũng có thể biến động
          theo từng khu vực khác nhau. Cụ thể tại TPHCM, những quận trung tâm
          như Quận 1, Quận 2, Quận 3, Quận 5… thường ghi nhận giá văn phòng phẩm
          đắt đỏ hơn những khu vực khác như quận Bình Thạnh, Phú Nhuận, Tân
          Bình, Gò Vấp hay Thủ Đức.
        </p>
        <h3>Nhu cầu sử dụng thực tế</h3>
        <p>
          Một yếu tố quan trọng khác ảnh hưởng đến giá thành văn phòng phẩm
          chính là nhu cầu của người sử dụng. Những sản phẩm có nhu cầu cao,
          được mua bán thường xuyên và hết hàng nhanh chóng sẽ có giá bán tăng
          cao. Ngược lại, những loại văn phòng phẩm ít được lựa chọn, nhu cầu sử
          dụng thấp thì mức giá sẽ theo chiều hướng giảm dần.
        </p>
        <div>
          <img
            src="/assets/cua-hang-vpp-2.jpeg"
            alt="Báo giá văn phòng phẩm phụ thuộc phần lớn vào nhu cầu sử dụng thực tế"
            className="img-fluid"
            style={{ maxWidth: '100%', margin: 'auto', display: 'block' }}
            width="600px"
            loading="lazy"
          />
        </div>
        <h3>Những yếu tố chủ quan từ nhà sản xuất và nhà cung cấp</h3>
        <p>
          Có một số yếu tố chủ quan từ phía nhà sản xuất hoặc nhà cung cấp cũng
          có thể khiến cho giá văn phòng phẩm tăng lên hoặc giảm đi:
        </p>
        <ul>
          <li>
            Mức chiết khấu dành cho những đơn đặt hàng số lượng lớn, chiết khấu
            càng cao thì người mua sẽ nhận được mức giá càng rẻ
          </li>
          <li>
            Chi phí vận chuyển văn phòng phẩm, một số đơn vị sẽ miễn hoặc giảm
            phí ship tùy theo tổng giá trị đơn hàng
          </li>
          <li>Chế độ bảo hành sản phẩm của nhà sản xuất</li>
          <li>Chính sách đổi trả hàng của đơn vị cung cấp</li>
        </ul>
        <h2>Những loại văn phòng phẩm thường xuyên biến động giá</h2>
        <p>
          Có một số mặt hàng văn phòng phẩm ghi nhận biến động giá thường xuyên.
          Vì vậy bạn nên theo dõi giá cả để đảm bảo mua sản phẩm đúng thời điểm
          với mức giá tốt nhất.
        </p>
        <h3>Các loại giấy in</h3>
        <p>
          Giấy in, giấy photocopy… là một trong những loại văn phòng phẩm được
          sử dụng rộng rãi nhất. Chính vì vậy mà giá thành giấy in cũng tăng
          giảm liên tục tùy từng thời điểm. Có thể nói, hầu hết mọi lĩnh vực
          trong đời sống như công việc, học tập, kho bãi, logistics… đều cần đến
          giấy in.
        </p>
        <p>
          Hiện nay các khổ giấy được dùng phổ biến nhất là A3, A4 và A5. Các
          loại giấy được ưa chuộng hiện nay phần lớn được nhập khẩu từ
          Indonesia, Malaysia và Thái Lan. Quá trình xuất nhập khẩu giấy in cũng
          tác động đến giá cả của sản phẩm.
        </p>
        <p>
          <img
            src="https://fast.vn/assets/banner-4/banner%204_780x240px.jpg"
            alt="Báo giá văn phòng phẩm đối với giấy in biến động khá thường xuyên"
            className="img-fluid"
            style={{ maxWidth: '100%', margin: 'auto', display: 'block' }}
            width="600px"
            loading="lazy"
          />
        </p>
        <h3>Các loại bìa hồ sơ</h3>
        <p>
          File đựng tài liệu, hồ sơ là vật dụng thiết yếu mà bất cứ bàn làm việc
          nào cũng phải có. Bìa hồ sơ được dùng để lưu trữ và sắp xếp gọn gàng
          các loại tài liệu, chứng từ, hóa đơn, giấy tờ… quan trọng phục vụ công
          việc. Chính vì nhu cầu sử dụng cao nên bìa hồ sơ cũng có giá biến động
          khá thường xuyên.
        </p>
        <p>
          Bìa đựng hồ sơ có nhiều loại như bìa lá, bìa trình ký, bìa còng… Hiện
          nay, bìa hồ sơ có thể được sản xuất trong nước hoặc nhập khẩu từ nước
          ngoài.
        </p>
        <h3>Một số đồ dùng văn phòng phẩm khác</h3>
        <p>
          So với giấy in và bìa hồ sơ thì những món đồ dùng văn phòng phẩm như
          sổ sách, bút viết, bấm lỗ, kẹp giấy, ghim bấm… thường có mức giá ổn
          định hơn. Mặc dù vậy, giá thành của những mặt hàng này vẫn chịu tác
          động của sự chênh lệch giá theo khu vực và theo thời điểm.
        </p>
        <h2>FAST – báo giá văn phòng phẩm uy tín, giá rẻ nhất hiện nay</h2>
        <p>
          Đến với FAST, khách hàng sẽ không phải lo lắng về giá thành văn phòng
          phẩm biến động. Chúng tôi luôn áp dụng mức giá hợp lý và cạnh tranh
          nhất thị trường đối với từng mặt hàng. Ngoài ra, FAST còn đưa ra nhiều
          chính sách ưu đãi cùng các chương trình chiết khấu, giảm giá hấp dẫn
          để quý khách tiết kiệm tối đa chi phí mua hàng.
        </p>
        <h3>Giao văn phòng phẩm miễn phí nội thành TPHCM</h3>
        <p>
          Dù khách hàng ở bất khu vực nào tại TPHCM như Thành phố Thủ Đức, Quận
          1, Quận 3, Quận 4, Quận 5, Quận 6, Quận 7, Quận 8, Quận 10, Quận 11,
          Quận 12, quận Bình Tân, quận Bình Thạnh, quận Gò Vấp, quận Phú Nhuận,
          quận Tân Bình, quận Tân Phú, huyện Bình Chánh, huyện Cần Giờ, huyện Củ
          Chi, huyện Hóc Môn hay huyện Nhà Bè, FAST cũng có thể giao văn phòng
          phẩm tận nơi chỉ trong 2 – 4 tiếng đồng hồ.
        </p>
        <h3>Giá gốc trực tiếp từ nhà sản xuất</h3>
        <p>
          FAST cam kết chỉ cung cấp các sản phẩm chính hãng của những thương
          hiệu nổi tiếng trong và ngoài nước như Thiên Long, Hồng Hà, Bến Nghé
          hay Campus, Deli, Staedtler… FAST luôn nhập hàng trực tiếp từ nhà máy
          với số lượng lớn, vì vậy quý khách hoàn toàn yên tâm sẽ nhận được giá
          gốc của nhà sản xuất.
        </p>
        <h2>Hướng dẫn cách nhận báo giá văn phòng phẩm từ FAST</h2>
        <p>
          Để được nhận bảng giá văn phòng phẩm từ FAST, bạn có thể liên hệ
          hotline 0964 399 099 để được nhân viên của chúng tôi tư vấn và báo giá
          trực tiếp. Ngoài ra khách hàng cũng có thể làm theo cách như sau:
        </p>
        <ul>
          <li>
            Bước 1: Truy cập website Fast.vn và nhấn nút Báo giá tại menu hiển
            thị bên phải màn hình.
          </li>
          <li>
            Bước 2: Tiếp theo bên dưới mục Gửi báo giá với file sẵn có, bạn điền
            các thông tin cá nhân của mình vào. Sau đó tải file danh mục sản
            phẩm cần báo giá lên (tối đa 3 file, định dạng hình ảnh, excel hoặc
            pdf). Cuối cùng nhấn nút Gửi FAST để gửi file cho chúng tôi.
          </li>
          <li>
            Bước 3: Sau khi nhận được yêu cầu của khách hàng, FAST sẽ rà soát
            từng sản phẩm và lên báo giá tương ứng. FAST sẽ gửi bảng giá chi
            tiết cho khách hàng qua Email hoặc liên hệ trực tiếp với quý khách.
          </li>
        </ul>
        <h2>Bảng giá văn phòng phẩm FAST chi tiết nhất, cập nhật mới nhất</h2>
        {/* <p>
          <img
            src="/assets/bao-gia-file.png"
            alt="Bảng giá văn phòng phẩm FAST chi tiết nhất, cập nhật mới nhất"
            className="img-fluid"
            style={{ maxWidth: '100%', margin: 'auto', display: 'block' }}
            width="600px"
            loading="lazy"
          />
        </p> */}
        <QuotationFiles />
        <p>
          Trên đây là những thông tin xoay quanh báo giá văn phòng phẩm của FAST
          mới nhất. Hy vọng rằng bạn sẽ lựa chọn FAST và gắn bó với chúng tôi
          lâu dài để được hưởng những chính sách ưu đãi về giá hấp dẫn nhất.
        </p>
      </div>
    </Container>
  );
};

export default memo(Quotation);
